import React, { useEffect } from "react";
import { connect } from "react-redux";
import { onLogin, MASTER_URL } from "../../middleware";
import Presentation from "./Presentation";

function Container(props) {
  useEffect(() => {
    if (!window.location.href.includes("http://localhost:3000/"))
      return window.open(`${MASTER_URL}/signout`, "_self");
  }, []);
  return (
    <div>
      <Presentation {...props} />
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  console.log(state);
  return {
    auth: state.firebase.auth,
    companyLogo: state.console.companyDetails["images"]
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onLogin: (creds) => {
      dispatch(onLogin(creds));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Container);
